import { formatUS, formatUSTwoDigits } from 'ns_libs/formatter';
import { isNaN } from 'lodash';

type LoanTerm = {
    loanTermMonths?: number;
    loanTermTime?: 'monthly' | 'yearly';
};

export function formatPercentageComparison(value: string | number | undefined): string {
    if (value === undefined || value === '' || value === null) {
        return '-';
    }

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (Number.isNaN(numericValue)) {
        return '-';
    }

    return `${numericValue.toFixed(1)}%`;
}

export const formatCurrencyComparison = (value: number): string => {
    if (value === undefined || value === null || isNaN(value)) {
        return '-';
    }

    const formatted = (value % 1 === 0 ? formatUS : formatUSTwoDigits).format(value);

    return formatted === '-$0' ? '$0' : formatted;
};

export const roundFormatComparison = (value: number, decimalPlaces: number = 0): string => {
    if (value === undefined || value === null || isNaN(value)) {
        return '-';
    }
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: decimalPlaces }).format(value);
};

export function formatLoanTerm({ loanTermMonths, loanTermTime }: LoanTerm): string {
    if (!loanTermMonths) return '-';

    if (loanTermTime === 'yearly') {
        return `${loanTermMonths} years`;
    }

    return `${loanTermMonths} months`;
}
